import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFile } from '../api/filesApi';
import { siteFilesKeys } from './useSiteFiles';
import { fileDetailKeys } from './useFileDetail';
import { useSnackbarStore } from '../../../shared/stores/snackbarStore';
import { recycleBinKeys } from '../api/recycleBinApi.ts';
import { folderContentsKeys } from './useFolderContents.ts';

export function useDeleteFile(siteId: number) {
  const queryClient = useQueryClient();
  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  return useMutation({
    mutationFn: (fileId: string) => deleteFile(fileId),
    onSuccess: (_data, fileId) => {
      queryClient.invalidateQueries({
        queryKey: siteFilesKeys.list(siteId),
      });
      queryClient.invalidateQueries({
        queryKey: folderContentsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: recycleBinKeys.all,
        refetchType: 'all',
      });
      queryClient.removeQueries({
        queryKey: fileDetailKeys.detail(fileId),
      });
      showSnackbar('File deleted', 'success');
    },
  });
}
